const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const POS_PRINT_STATUSES = {
  QUEUED: "QUEUED",
  PRINTED: "PRINTED",
  FAILED: "FAILED",
};

export const isEmptyPrintJobId = (printJobId) =>
  !printJobId || String(printJobId).trim() === EMPTY_GUID;

export const getPosPrintStatusMeta = (status) => {
  switch (String(status || "").toUpperCase()) {
    case POS_PRINT_STATUSES.PRINTED:
      return {
        tone: "success",
        title: "Invoice printed",
        message: "Receipt printed successfully.",
        isTerminal: true,
      };
    case POS_PRINT_STATUSES.FAILED:
      return {
        tone: "error",
        title: "Print failed",
        message: "Receipt could not be printed.",
        isTerminal: true,
      };
    case POS_PRINT_STATUSES.QUEUED:
    default:
      return {
        tone: "info",
        title: "Sending to printer",
        message: "Receipt is being sent to the printer.",
        isTerminal: false,
      };
  }
};

export const getPosPrintErrorMessage = (error) => {
  const code =
    error?.data?.code ||
    error?.data?.title ||
    error?.data?.errorCode ||
    error?.status;

  if (code === "DEVICE_NOT_FOUND") {
    return "Printing device was not found. Re-login or re-pair the device.";
  }

  if (code === "INVOICE_NOT_FOUND") {
    return "Invoice not found. Refresh the invoice list and try again.";
  }

  if (code === 403 || code === "FORBIDDEN") {
    return "Printing is not allowed for the current device or store context.";
  }

  return (
    error?.data?.detail ||
    error?.data?.message ||
    error?.error ||
    "Unable to start receipt printing."
  );
};

export const getPrintJobFailureMessage = (printJob) =>
  printJob?.lastError ||
  "Printing failed. Please retry the receipt print request.";
